export default __webpack_public_path__ + "static/media/arrow_blue-tata-neu.56801128.png";